import Vue from 'vue'
import Router from 'vue-router'
import frame from '@/components/frame'
import http from '@/assets/js/http'
const routerView = { template: `<router-view></router-view>` };
import { Message } from 'element-ui';

Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/',
            name: 'index',
            component: () => import('../pages/index'),
            meta: {
                showMenu: false,//是否显示
            }
        },
        {
            path: '/login',
            name: 'login',
            component: () => import('../pages/login'),
            meta: {
                title: '登录',
                showMenu: false,//是否显示
            }
        },
        /**
         * 厂商路由
         */
        //仪表盘
        {
            path: '/dashboard',
            name: 'dashboard',
            redirect: { name: 'dashboardIndex' },
            component: frame,
            meta: {
                title: '仪表盘',
                showMenu: true,//是否显示
                icon: "icon--2",
                userType: 2//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'index',
                    name: 'dashboardIndex',
                    component: () => import('../pages/dashboard/index'),
                    meta: {
                        title: '仪表盘',
                        showMenu: false,//是否显示
                        intercept: true,//是否拦截
                    },
                }

            ]
        },
        //资产
        {
            path: '/assets',
            name: 'assets',
            redirect: { name: 'assetsWebList' },
            component: frame,
            meta: {
                title: '资产管理',
                showMenu: true,//是否显示
                icon: " icon--3",
                userType: 2//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            // routerView
            children: [
                {
                    path: 'web',
                    name: 'webindex',
                    component: routerView,
                    redirect: { name: 'assetsWebList' },
                    meta: {
                        title: '站点管理',
                        showMenu: true,//是否显示
                        intercept: true,//是否拦截
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'assetsWebList',
                            component: () => import('../pages/company/assets/web/list'),
                            meta: {
                                title: '站点管理',
                                showMenu: true,//是否显示
                                intercept: true,//是否拦截
                            }
                        },
                        {
                            path: 'pay',
                            name: 'assetsOrdercheck',
                            component: () => import('../pages/company/assets/web/ordercheck'),
                            meta: {
                                title: '购买资产支付',
                                showMenu: true,//是否显示
                                intercept: true,//是否拦截
                            }
                        },
                        // {
                        //     path: 'ordercheck',
                        //     name: 'assetsOrdercheck',
                        //     component: () => import('../pages/company/assets/web/ordercheck'),
                        //     meta:{
                        //         title:'购买资产支付',
                        //         showMenu:true,//是否显示
                        //     }
                        // },
                        {
                            path: 'administration',
                            name: 'assetsWebAdministration',
                            component: () => import('../pages/company/assets/web/administration'),
                            meta: {
                                title: '资产管理',
                                showMenu: true,//是否显示
                                intercept: true,//是否拦截
                            }
                        },
                        {
                            path: 'groupList',
                            name: 'assetsWebGroupList',
                            component: () => import('../pages/company/assets/web/groupList'),
                            meta: {
                                title: '分组列表',
                                showMenu: true,//是否显示
                                intercept: true,//是否拦截
                            }
                        }
                    ]
                }
            ]
        },
        //安全服务
        {
            path: '/security',
            name: 'security',
            redirect: { name: 'securityLoophole' },
            component: frame,
            meta: {
                title: '安全服务',
                showMenu: true,//是否显示
                icon: "icon--5",
                userType: 2//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            //进入路由
            beforeEnter(to, from, next) {
                http.getauthinfo()
                    .then(res => {
                        if (!res || res.examineflag == 0 || res.examineflag == 2) {
                            next({ name: 'authentication' });
                            return false
                        }
                        if (res.type == 0) {
                            Message.error('个人用户无法使用此功能，请升级企业实名认证');
                            next({ name: 'authentication' });
                            return false
                        }
                        next();
                    });
            },
            children: [
                {
                    path: 'loophole',
                    name: 'securityLoophole',
                    component: () => import('../pages/security/loophole'),
                    meta: {
                        title: '我的漏洞',
                        showMenu: true,
                        intercept: true,//是否拦截
                    },
                },
                {
                    path: 'bugshow',
                    name: 'securityBugShow',
                    component: () => import('../pages/security/bugshow'),
                    meta: {
                        title: '漏洞详情',
                        showMenu: false,
                        intercept: true,//是否拦截
                    },
                }, {
                    path: 'report',
                    name: 'securityReport',
                    component: () => import('../pages/security/report'),
                    meta: {
                        title: '安全报告',
                        showMenu: true,
                        intercept: true,//是否拦截
                    },
                }
            ]
        },
        //资产探测
        {
            path: '/assettesting',
            name: 'assettesting',
            redirect: { name: 'assetList' },
            component: frame,
            meta: {
                title: '资产探测',
                showMenu: true,//是否显示
                icon: "icon--724",
                userType: 2//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            //进入路由
            beforeEnter(to, from, next) {
                let authinf = localStorage.getItem('authinf') ? JSON.parse(localStorage.getItem('authinf')) : '';
                if (!authinf || authinf.examineflag === 0 || authinf.examineflag === 2) {
                    next({ name: 'authentication' });
                    return false
                }
                if (authinf.type === 0) {
                    Message.error('个人用户无法使用此功能，请升级企业实名认证');
                    next({ name: 'authentication' });
                    return false
                }
                //查询是否开通资产探测
                http.getdeepeyeopeninfo()
                    .then(res => {
                        if (res.orderflag !== 2) {
                            Message.error('请先开通企业资产探测业务');
                            next({ name: 'openAssettesting' });
                            return false
                        }
                        next();
                    })
            },
            children: [
                {
                    path: 'assetinglist',
                    name: 'assetingindex',
                    component: routerView,
                    redirect: { name: 'assetList' },
                    meta: {
                        title: '资产列表',
                        showMenu: true,//是否显示
                        intercept: true,//是否拦截
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'assetList',
                            component: () => import('../pages/assettesting/assetList'),
                            meta: {
                                title: '资产列表',
                                showMenu: true,//是否显示
                                intercept: true,//是否拦截
                            }
                        },

                    ]
                }
            ]
        },
        //开通资产探测
        {
            path: '/openingasset',
            name: 'openingasset',
            redirect: { name: 'openAssettesting' },
            component: frame,
            meta: {
                title: '开通项目',
                showMenu: false,//是否显示
                icon: "icon--7",
                userType: 2//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                //开通资产探测
                {
                    path: 'atopen',
                    name: 'openAssettesting',
                    component: () => import('../pages/assettesting/openingAssetesting'),
                    meta: {
                        title: '开通资产探测',
                        showMenu: false
                    }
                },
                //开通企业src订单页面
                {
                    path: 'atorder',
                    name: 'assettestingorder',
                    component: () => import('../pages/assettesting/checkorder'),
                    meta: {
                        title: '开通资产探测',
                        showMenu: false
                    }
                },
            ]
        },
        //企业SRC
        {
            path: '/src',
            name: 'src',
            redirect: { name: 'noticeList' },
            component: frame,
            meta: {
                title: '企业SRC',
                showMenu: true,//是否显示
                icon: "icon--52",
                userType: 2//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            //进入路由
            beforeEnter(to, from, next) {
                let authinf = localStorage.getItem('authinf') ? JSON.parse(localStorage.getItem('authinf')) : '';
                if (!authinf || authinf.examineflag === 0 || authinf.examineflag === 2) {
                    next({ name: 'authentication' });
                    return false
                }
                if (authinf.type === 0) {
                    Message.error('个人用户无法使用此功能，请升级企业实名认证');
                    next({ name: 'authentication' });
                    return false
                }
                //查询是否开通SRC
                http.getsrcopeninfo()
                    .then(res => {
                        if (res.orderflag !== 2) {
                            Message.error('请先开通企业SRC业务');
                            next({ name: 'openingSrc' });
                            return false
                        }
                        next();
                    })
            },
            children: [
                {
                    path: 'notice',
                    name: 'notice',
                    redirect: { name: 'noticeList' },
                    component: routerView,
                    meta: {
                        title: '企业公告',
                        showMenu: true,
                        intercept: true,//是否拦截
                    },
                    beforeEnter(to, from, next) {
                        srcBeforeEnter(next)
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'noticeList',
                            component: () => import('../pages/src/noticeList'),
                            meta: {
                                title: '公告列表',
                                showMenu: true,
                                intercept: true,//是否拦截
                            },
                        },
                        {
                            path: 'operation',
                            name: 'noticeOperation',
                            component: () => import('../pages/src/noticeOperation'),
                            meta: {
                                title: '公告列表',
                                showMenu: true,
                                intercept: true,//是否拦截
                            },
                        }
                    ]
                },
                //礼品中心
                {
                    path: 'gift',
                    name: 'gift',
                    redirect: { name: 'productList' },
                    component: routerView,
                    meta: {
                        title: '礼品中心',
                        showMenu: true,
                        intercept: true,//是否拦截
                    },
                    beforeEnter(to, from, next) {
                        srcBeforeEnter(next)
                    },
                    children: [
                        {
                            path: 'productList',
                            name: 'productList',
                            component: () => import('../pages/src/productList'),
                            meta: {
                                title: '礼品列表',
                                showMenu: false,
                                intercept: true,//是否拦截
                            }
                        },
                        {
                            path: 'productOperation',
                            name: 'productOperation',
                            component: () => import('../pages/src/productOperation'),
                            meta: {
                                title: '新增或编辑礼品',
                                showMenu: false,
                                intercept: true,//是否拦截
                            }
                        }
                    ]
                },
                //订单管理
                {
                    path: 'order',
                    name: 'order',
                    redirect: { name: 'orderList' },
                    component: routerView,
                    meta: {
                        title: '订单管理',
                        showMenu: true
                    },
                    beforeEnter(to, from, next) {
                        srcBeforeEnter(next)
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'orderList',
                            component: () => import('../pages/src/orderList'),
                            meta: {
                                title: '订单列表',
                                showMenu: false,
                                intercept: true,//是否拦截
                            }
                        },
                        {
                            path: 'edit',
                            name: 'orderEdit',
                            component: () => import('../pages/src/orderOperation'),
                            meta: {
                                title: '编辑订单',
                                showMenu: false,
                                intercept: true,//是否拦截
                            }
                        }
                    ]
                },
                //品牌设置
                {
                    path: 'brand',
                    name: 'brand',
                    component: () => import('../pages/src/brand'),
                    meta: {
                        title: '品牌设置',
                        showMenu: true,
                        intercept: true,//是否拦截
                    }
                },
                {
                    path: 'domain',
                    name: 'domain',
                    component: () => import('../pages/src/domain'),
                    meta: {
                        title: '域名设置',
                        showMenu: true,
                        intercept: true,//是否拦截
                    },
                    beforeEnter(to, from, next) {
                        srcBeforeEnter(next)
                    }
                },
            ]
        },
        //威胁情报
        {
            path: '/threaten',
            name: 'threaten',
            redirect: { name: 'threaten_lists' },
            component: frame,
            meta: {
                title: '威胁情报',
                showMenu: true,//是否显示
                icon: "icon--6",
                userType: 2//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: '',
                    name: 'threaten_index',
                    component: routerView,
                    meta: {
                        title: '威胁情报',
                        showMenu: false
                    },
                    children: [
                        {
                            path: 'lists',
                            name: 'threaten_lists',
                            component: () => import('../pages/company/security/lists'),
                            meta: {
                                title: '威胁情报',
                                showMenu: false,
                                intercept: true,//是否拦截
                            }
                        },
                        {
                            path: '/threaten/show',
                            name: 'threaten_show',
                            component: () => import('../pages/company/security/show'),
                            meta: {
                                title: '威胁情报详情',
                                showMenu: false,
                                intercept: true,//是否拦截
                            },
                        },
                        {
                            path: '/threaten/ordercheck',
                            name: 'threaten_ordercheck',
                            component: () => import('../pages/company/security/ordercheck'),
                            meta: {
                                title: '确认订单',
                                showMenu: false,
                                intercept: true,//是否拦截
                            },
                        }
                    ]
                }
            ]
        },
        //开通项
        {
            path: '/opening',
            name: 'opening',
            redirect: { name: 'openingSrc' },
            component: frame,
            meta: {
                title: '开通项目',
                showMenu: false,//是否显示
                icon: "icon--7",
                userType: 2//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                //开通企业SRC
                {
                    path: 'openingSrc',
                    name: 'openingSrc',
                    component: () => import('../pages/src/openingSrc'),
                    meta: {
                        title: '开通企业src',
                        showMenu: false
                    }
                },
                //开通企业src订单页面
                {
                    path: 'src',
                    name: 'srccheckorder',
                    component: () => import('../pages/src/checkorder'),
                    meta: {
                        title: '开通企业src',
                        showMenu: false
                    }
                },
            ]
        },
        //ssl管理
        {
            path: '/ssl',
            name: 'ssl',
            redirect: { name: 'sslList' },
            component: frame,
            meta: {
                title: 'SSL管理',
                showMenu: true,//是否显示
                icon: "icon--7",
                userType: 2//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'ssl',
                    name: 'sslmenu',
                    redirect: { name: 'sslList' },
                    component: routerView,
                    meta: {
                        title: 'SSL管理',
                        showMenu: true,
                        intercept: true,//是否拦截
                    },
                    children: [
                        {
                            path: 'list',
                            name: 'sslList',
                            component: () => import('../pages/company/ssl/list'),
                            meta: {
                                title: 'SSL管理',
                                showMenu: false,
                                intercept: true,//是否拦截
                            }
                        },
                        {
                            path: 'buy',
                            name: 'sslBuy',
                            component: () => import('../pages/company/ssl/buy'),
                            meta: {
                                title: '购买证书',
                                showMenu: false,
                                intercept: true,//是否拦截
                            }
                        },
                        {
                            path: 'order',
                            name: 'sslOrderCheck',
                            component: () => import('../pages/company/ssl/ordercheck'),
                            meta: {
                                title: '订单核对',
                                showMenu: false,
                                intercept: true,//是否拦截
                            }
                        },
                        {
                            path: 'issue',
                            name: 'sslIssue',
                            component: () => import('../pages/company/ssl/issue'),
                            meta: {
                                title: '签发证书',
                                showMenu: false,
                                intercept: true,//是否拦截
                            }
                        },
                        {
                            path: 'orderdetails',
                            name: 'orderdetails',
                            component: () => import('../pages/company/ssl/orderdetails'),
                            meta: {
                                title: '签发证书',
                                showMenu: false,
                                intercept: true,//是否拦截
                            }
                        },
                        {
                            path: 'againAward',
                            name: 'againAward',
                            component: () => import('../pages/company/ssl/againAward'),
                            meta: {
                                title: '重新颁发证书',
                                showMenu: false,
                                intercept: true,//是否拦截
                            }
                        },
                        {
                            path: 'reissuedetails',
                            name: 'reissuedetails',
                            component: () => import('../pages/company/ssl/reissuedetails'),
                            meta: {
                                title: '重新颁发证书详情',
                                showMenu: false,
                                intercept: true,//是否拦截
                            }
                        },
                    ]
                },
                {
                    path: 'cert',
                    name: 'sslcert',
                    component: () => import('../pages/company/ssl/sslcert'),
                    meta: {
                        title: '证书管理',
                        showMenu: true
                    }
                },
                {
                    path: 'certmonitor',
                    name: 'sslcertlist',
                    component: () => import('../pages/company/ssl/certmonitor'),
                    meta: {
                        title: '证书监控',
                        showMenu: true
                    }
                }
            ]
        },
        {
            path: '/api',
            name: 'api',
            redirect: { name: 'apiList' },
            component: frame,
            meta: {
                title: 'API市场',
                showMenu: true,//是否显示
                icon: "icon--53",
                userType: 2//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'list',
                    name: 'apiList',
                    component: () => import('../pages/company/api/mylist'),
                    meta: {
                        title: '我的API',
                        showMenu: true,
                        intercept: true,//是否拦截
                    },
                },
                {
                    path: 'apply',
                    name: 'apiApply',
                    component: () => import('../pages/company/api/apply'),
                    meta: {
                        title: '申请API',
                        showMenu: true,
                        intercept: true,//是否拦截
                    },
                },
                {
                    path: 'ordercheck',
                    name: 'apiOrderCheck',
                    component: () => import('../pages/company/api/ordercheck'),
                    meta: {
                        title: 'API订单',
                        showMenu: false,
                        intercept: true,//是否拦截
                    },
                },
                {
                    path: 'statistics',
                    name: 'apiStatistics',
                    component: () => import('../pages/company/api/statistics'),
                    meta: {
                        title: 'API统计',
                        showMenu: false,
                        intercept: true,//是否拦截
                    },
                },
                {
                    path: 'white',
                    name: 'apiIPWhite',
                    component: () => import('../pages/company/api/white'),
                    meta: {
                        title: 'ip白名单',
                        showMenu: true,
                        intercept: true,//是否拦截
                    },
                },
                {
                    path: 'test',
                    name: 'apiTest',
                    component: () => import('../pages/company/api/test'),
                    meta: {
                        title: '接口测试',
                        showMenu: false,
                        intercept: true,//是否拦截
                    },
                }
            ]
        },
        //信任中心
        {
            path: '/trust',
            name: 'trust',
            redirect: { name: 'trustlist' },
            component: frame,
            meta: {
                title: '信任中心',
                showMenu: true,//是否显示
                icon: "icon--53",
                userType: 2//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'list',
                    name: 'trustlist',
                    component: () => import('../pages/company/trust/list'),
                    meta: {
                        title: '网站安全',
                        showMenu: true,
                        intercept: true,//是否拦截
                    },
                },
                {
                    path: 'apply',
                    name: 'trustapply',
                    component: () => import('../pages/company/trust/apply'),
                    meta: {
                        title: '申请认证',
                        showMenu: false
                    },
                }
            ]
        },
        //费用中心
        {
            path: '/cost',
            name: 'cost',
            redirect: { name: 'costindex' },
            component: frame,
            meta: {
                title: '费用中心',
                showMenu: true,//是否显示
                icon: "icon--9",
                userType: 2//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'index',
                    name: 'costindex',
                    component: () => import('../pages/company/cost/index'),
                    meta: {
                        title: '费用中心',
                        showMenu: true,
                        intercept: true,//是否拦截
                    },
                },
                {
                    path: 'budgetList',
                    name: 'budgetList',
                    component: () => import('../pages/company/cost/budgetList'),
                    meta: {
                        title: '收支明细',
                        showMenu: true,
                        intercept: true,//是否拦截
                    },
                },
                {
                    path: 'order',
                    name: 'budgetOrder',
                    component: () => import('../pages/company/cost/order'),
                    meta: {
                        title: '订单管理',
                        showMenu: true,
                        intercept: true,//是否拦截
                    },
                },
                {
                    path: 'renew',
                    name: 'renew',
                    component: () => import('../pages/company/cost/renew'),
                    meta: {
                        title: '续费管理',
                        showMenu: true,
                        intercept: true,//是否拦截
                    },
                },
                {
                    path: 'invoice',
                    name: 'invoice',
                    component: routerView,
                    redirect: { name: 'invoiceIndex' },
                    meta: {
                        title: '发票管理',
                        showMenu: true
                    },
                    children: [
                        {
                            path: 'index',
                            name: 'invoiceIndex',
                            component: () => import('../pages/company/cost/invoice'),
                            meta: {
                                title: '发票管理',
                                showMenu: false,
                                intercept: true,//是否拦截
                            }
                        },
                        {
                            path: 'Apply',
                            name: 'applicationinvoice',
                            component: () => import('../pages/company/cost/applicationinvoice'),
                            meta: {
                                title: '申请发票',
                                showMenu: false,
                                intercept: true,//是否拦截
                            }
                        }
                    ]
                }
            ]
        },
        //用户中心
        {
            path: '/userCenter',
            name: 'userCenter',
            redirect: { name: 'personalData' },
            component: frame,
            meta: {
                title: '用户中心',
                showMenu: true,//是否显示
                icon: "icon--8",
                userType: 2//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'personalData',
                    name: 'personalData',
                    component: () => import('../pages/userCenter/personalData'),
                    meta: {
                        title: '个人资料',
                        showMenu: true,
                        intercept: true,//是否拦截
                    }
                },
                {
                    path: 'authentication',
                    name: 'authentication',
                    component: () => import('../pages/userCenter/authentication'),
                    meta: {
                        title: '实名认证',
                        showMenu: true
                    }
                },
                {
                    path: 'authmode',
                    name: 'authmode',
                    component: () => import('../pages/userCenter/auth/auth_type'),
                    meta: {
                        title: '认证类型',
                        showMenu: false
                    }
                },
                //个人认证方式选择
                {
                    path: 'personal_mode',
                    name: 'auth_personal_mode',
                    component: () => import('../pages/userCenter/auth/personal/mode'),
                    meta: {
                        title: '选择认证方式',
                        showMenu: false
                    }
                },
                //企业认证方式选择
                {
                    path: 'enterprise_mode',
                    name: 'auth_enterprise_mode',
                    component: () => import('../pages/userCenter/auth/enterprise/mode'),
                    meta: {
                        title: '选择认证方式',
                        showMenu: false
                    }
                },
                //人脸识别
                {
                    path: 'auth_face',
                    name: 'auth_face',
                    component: () => import('../pages/userCenter/auth/personal/face'),
                    meta: {
                        title: '人脸识别认证',
                        showMenu: false
                    }
                },
                //个人认证资料填写
                {
                    path: 'personal_data',
                    name: 'auth_personal_data',
                    component: () => import('../pages/userCenter/auth/personal/data'),
                    meta: {
                        title: '资料填写',
                        showMenu: false
                    }
                },
                //企业认证资料填写
                {
                    path: 'enterprise_data',
                    name: 'auth_enterprise_data',
                    component: () => import('../pages/userCenter/auth/enterprise/data'),
                    meta: {
                        title: '资料填写',
                        showMenu: false
                    }
                },
                {
                    path: 'early_warning',
                    name: 'early_warning',
                    component: () => import('../pages/userCenter/early_warning'),
                    meta: {
                        title: '预警管理',
                        showMenu: true,
                        intercept: true,//是否拦截
                    }
                },
                {
                    path: 'payPassword',
                    name: 'payPassword',
                    component: () => import('../pages/userCenter/paypassword'),
                    meta: {
                        title: '支付密码设置',
                        showMenu: true,
                        intercept: true,//是否拦截
                    }
                },
                {
                    path: 'safe',
                    name: 'safe',
                    component: () => import('../pages/userCenter/safe'),
                    meta: {
                        title: '修改密码',
                        showMenu: false
                    }
                },
                {
                    path: 'ak',
                    name: 'AK',
                    component: () => import('../pages/userCenter/ak/lists'),
                    meta: {
                        title: '多云AK管理',
                        showMenu: true,
                        intercept: true,//是否拦截
                    }
                }
            ]
        },
        //公用订单页面
        {
            path: '/order',
            name: 'comorder',
            redirect: { name: 'orderindex' },
            component: frame,
            meta: {
                title: '订单确认',
                showMenu: false,//是否显示
                icon: "icon--9",
                userType: 2//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'confirm',
                    name: 'orderindex',
                    component: () => import('../pages/company/comorder/index'),
                    meta: {
                        title: '订单确认',
                        showMenu: false
                    }
                },
            ]
        },

        /**
         * 白帽路由
         */
        {
            path: '/whinfo',
            name: 'whinfo',
            redirect: { name: 'whinfoIndex' },
            component: frame,
            meta: {
                title: '仪表盘',
                showMenu: true,//是否显示
                icon: "icon--2",
                userType: 1//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'index',
                    name: 'whinfoIndex',
                    component: () => import('../pages/whinfo/index'),
                    meta: {
                        title: '仪表盘',
                        showMenu: false,//是否显示
                    },
                    beforeEnter: (to, from, next) => {
                        whinfogetauth(next)
                    }
                }
            ]
        },
        //我的漏洞
        {
            path: '/mybug',
            name: 'mybug',
            redirect: { name: 'toExamine' },
            component: frame,
            meta: {
                title: '我的漏洞',
                showMenu: true,//是否显示
                icon: "icon--6",
                userType: 1//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            beforeEnter: (to, from, next) => {
                whinfogetauth(next)
            },
            children: [
                {
                    path: 'toExamine',
                    name: 'toExamine',
                    component: () => import('../pages/whinfo/mybug/toExamine'),
                    meta: {
                        title: '已审核',
                        showMenu: true,//是否显示
                    }
                },
                {
                    path: 'toBeAudited',
                    name: 'toBeAudited',
                    component: () => import('../pages/whinfo/mybug/toBeAudited'),
                    meta: {
                        title: '待审核',
                        showMenu: true,//是否显示
                    }
                },
                {
                    path: 'totest',
                    name: 'toTest',
                    component: () => import('../pages/whinfo/mybug/toTest'),
                    meta: {
                        title: '待复测',
                        showMenu: true,//是否显示
                    }
                },
                {
                    path: 'ignore',
                    name: 'ignore',
                    component: () => import('../pages/whinfo/mybug/ignore'),
                    meta: {
                        title: '已忽略',
                        showMenu: true,//是否显示
                    }
                },
                {
                    path: 'addbug',
                    name: 'addbug',
                    component: () => import('../pages/whinfo/mybug/addbug'),
                    meta: {
                        title: '添加漏洞',
                        showMenu: false,//是否显示
                    }
                },
                {
                    path: 'bugshow',
                    name: 'bugshow',
                    component: () => import('../pages/whinfo/mybug/bugshow'),
                    meta: {
                        title: '漏洞详情',
                        showMenu: false,//是否显示
                    }
                }
            ]
        },
        //项目大厅
        {
            path: '/project',
            name: 'project',
            redirect: { name: 'projectList' },
            component: frame,
            meta: {
                title: '项目管理',
                showMenu: true,//是否显示
                icon: "icon--6",
                userType: 1//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            beforeEnter: (to, from, next) => {
                whinfogetauth(next)
            },
            children: [
                {
                    path: 'projectList',
                    name: 'projectList',
                    component: () => import('../pages/whinfo/project/list'),
                    meta: {
                        title: '项目大厅',
                        showMenu: true,//是否显示
                    }
                },
                {
                    path: 'projectMy',
                    name: 'projectMy',
                    component: () => import('../pages/whinfo/project/my'),
                    meta: {
                        title: '我的项目',
                        showMenu: true,//是否显示
                    }
                },
                {
                    path: 'projectDetails',
                    name: 'projectDetails',
                    component: () => import('../pages/whinfo/project/details'),
                    meta: {
                        title: '项目详情',
                        showMenu: false,//是否显示
                    }
                }
            ]
        },
        //厂商列表
        {
            path: '/company',
            name: 'company',
            component: frame,
            redirect: { name: 'companylist' },
            meta: {
                title: 'SRC列表',
                showMenu: true,//是否显示
                icon: "icon--3",
                userType: 1//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            beforeEnter: (to, from, next) => {
                whinfogetauth(next)
            },
            children: [
                {
                    path: 'list',
                    name: 'companylist',
                    component: () => import('../pages/src/companylist'),
                    meta: {
                        title: 'SRC列表',
                        showMenu: true,//是否显示
                    }
                }
            ]
        },
        //礼品中心
        {
            path: '/whgift',
            name: 'whgift',
            redirect: { name: 'mygift' },
            component: frame,
            meta: {
                title: '礼品中心',
                showMenu: true,//是否显示
                icon: "icon--69",
                userType: 1//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            beforeEnter: (to, from, next) => {
                whinfogetauth(next)
            },
            children: [
                {
                    path: 'mygift',
                    name: 'mygift',
                    component: () => import('../pages/whinfo/gift/mygift'),
                    meta: {
                        title: '我的礼品',
                        showMenu: true,//是否显示
                    }
                },
                {
                    path: 'integral',
                    name: 'integral',
                    component: () => import('../pages/whinfo/gift/integral'),
                    meta: {
                        title: '我的积分',
                        showMenu: true,//是否显示
                    }
                },
            ]
        },
        //用户中心
        {
            path: '/whusercenter',
            name: 'whusercenter',
            redirect: { name: 'accountinfo' },
            component: frame,
            meta: {
                title: '用户中心',
                showMenu: true,//是否显示
                icon: "icon--8",
                userType: 1//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'accountinfo',
                    name: 'accountinfo',
                    component: () => import('../pages/whinfo/usercenter/accountinfo'),
                    meta: {
                        title: '账户信息',
                        showMenu: true,//是否显示
                    },
                    beforeEnter: (to, from, next) => {
                        whinfogetauth(next)
                    }
                },
                {
                    path: 'receivables',
                    name: 'receivables',
                    component: () => import('../pages/whinfo/usercenter/receivables'),
                    meta: {
                        title: '收款信息',
                        showMenu: true,//是否显示
                    },
                    beforeEnter: (to, from, next) => {
                        whinfogetauth(next)
                    }
                },
                {
                    path: 'auth',
                    name: 'auth',
                    component: () => import('../pages/whinfo/auth/index'),
                    meta: {
                        title: '用户认证',
                        showMenu: true,//是否显示
                    },
                    beforeEnter: (to, from, next) => {
                        whinfogetauth(next)
                    }
                },
                {
                    path: 'face',
                    name: 'face',
                    component: () => import('../pages/whinfo/auth/face'),
                    meta: {
                        title: '人脸认证',
                        showMenu: false,//是否显示
                    }
                },
                {
                    path: 'data',
                    name: 'whinfoauthdata',
                    component: () => import('../pages/whinfo/auth/data'),
                    meta: {
                        title: '身份认证',
                        showMenu: false,//是否显示
                    }
                },
                {
                    path: 'applyauth',
                    name: 'applyauth',
                    component: () => import('../pages/whinfo/auth/apply'),
                    meta: {
                        title: '申请认证',
                        showMenu: false,//是否显示
                    }
                },
                {
                    path: 'showdata',
                    name: 'showdata',
                    component: () => import('../pages/whinfo/auth/showdata.vue'),
                    meta: {
                        title: '认证信息展示',
                        showMenu: false,//是否显示
                    },
                    beforeEnter: (to, from, next) => {
                        whinfogetauth(next)
                    }
                },
                {
                    path: 'whmodifypass',
                    name: 'whmodifypass',
                    component: () => import('../pages/whinfo/usercenter/modifypass'),
                    meta: {
                        title: '修改密码',
                        showMenu: true,//是否显示
                    }
                },
            ]
        },
        /**
         * 管理员路由
         */
        {
            path: '/adminindex',
            name: 'adminindex',
            redirect: { name: 'adminindex' },
            component: frame,
            meta: {
                title: '仪表盘',
                showMenu: true,//是否显示
                icon: "el-icon-monitor",
                userType: 3//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'index',
                    name: 'adminindex',
                    component: () => import('../pages/admin/index'),
                    meta: {
                        title: '仪表盘',
                        showMenu: false,//是否显示
                    }
                }
            ]
        },
        //企业管理
        {
            path: '/enterprise',
            name: 'enterprise',
            redirect: { name: 'enterpriseList' },
            component: frame,
            meta: {
                title: '企业管理',
                showMenu: true,//是否显示
                icon: "el-icon-office-building",
                userType: 3//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'list',
                    name: 'enterpriseList',
                    component: () => import('../pages/admin/companylist'),
                    meta: {
                        title: '企业列表',
                        showMenu: false,//是否显示
                    }
                },
                {
                    path: 'details',
                    name: 'enterpriseDetails',
                    component: () => import('../pages/admin/companydetails'),
                    meta: {
                        title: '企业列表',
                        showMenu: false,//是否显示
                    }
                },
                {
                    path: 'recharge',
                    name: 'adminrecharge',
                    component: () => import('../pages/admin/recharge'),
                    meta: {
                        title: '充值记录',
                        showMenu: true,//是否显示
                    }
                },
                {
                    path: 'coupon',
                    name: 'admincoupon',
                    component: () => import('../pages/admin/coupon'),
                    meta: {
                        title: '优惠券',
                        showMenu: true,//是否显示
                    }
                }
            ]
        },
        //白帽管理
        {
            path: '/whitecap',
            name: 'whitecap',
            redirect: { name: 'whitecapList' },
            component: frame,
            meta: {
                title: '白帽管理',
                showMenu: true,//是否显示
                icon: "el-icon-user",
                userType: 3//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'list',
                    name: 'whitecapList',
                    component: () => import('../pages/admin/wh'),
                    meta: {
                        title: '白帽列表',
                        showMenu: false,//是否显示
                    }
                },
                {
                    path: 'details',
                    name: 'enterpriseDetails',
                    component: () => import('../pages/admin/companydetails'),
                    meta: {
                        title: '企业列表',
                        showMenu: false,//是否显示
                    }
                }
            ]
        },
        {
            path: '/adminsecurityReport',
            name: 'adminsecurityReport',
            redirect: { name: 'adminsecurityReportList' },
            component: frame,
            meta: {
                title: '安全服务报告',
                showMenu: true,//是否显示
                icon: "el-icon-warning-outline",
                userType: 3//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'list',
                    name: 'adminsecurityReportList',
                    component: () => import('../pages/admin/securityReport'),
                    meta: {
                        title: '报告列表',
                        showMenu: false,//是否显示
                    }
                },
                {
                    path: 'show',
                    name: 'adminsecurityReportShow',
                    component: () => import('../pages/admin/securityReportShow'),
                    meta: {
                        title: '报告列表',
                        showMenu: false,//是否显示
                    }
                }
            ]
        },
        //漏洞管理
        {
            path: '/bug',
            name: 'bug',
            redirect: { name: 'bugList' },
            component: frame,
            meta: {
                title: '漏洞管理',
                showMenu: true,//是否显示
                icon: "el-icon-warning-outline",
                userType: 3//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'list',
                    name: 'bugList',
                    component: () => import('../pages/admin/buglist'),
                    meta: {
                        title: '漏洞列表',
                        showMenu: false,//是否显示
                    }
                },
                {
                    path: 'show',
                    name: 'bugShow',
                    component: () => import('../pages/admin/bugshow'),
                    meta: {
                        title: '漏洞详情',
                        showMenu: false,//是否显示
                    }
                }
            ]
        },
        // 预警管理
        {
            path: '/earlywarning',
            name: 'earlywarning',
            redirect: { name: 'earlywarning_list' },
            component: frame,
            meta: {
                title: '预警管理',
                showMenu: true,//是否显示
                icon: "el-icon-monitor",
                userType: 3//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'list',
                    name: 'earlywarning_list',
                    component: () => import('../pages/admin/earlywarningList'),
                    meta: {
                        title: '预警管理',
                        showMenu: false,//是否显示
                    }
                },
                {
                    path: 'add',
                    name: 'earlywarning_add',
                    component: () => import('../pages/admin/earlywarningAdd'),
                    meta: {
                        title: '新增预警',
                        showMenu: false,//是否显示
                    }
                }
            ]
        },
        //信任中心
        {
            path: '/admintrust',
            name: 'admintrust',
            redirect: { name: 'admintrustlist' },
            component: frame,
            meta: {
                title: '信任中心',
                showMenu: true,//是否显示
                icon: "el-icon-monitor",
                userType: 3//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'admintrustlist',
                    name: 'admintrustlist',
                    component: () => import('../pages/admin/trust'),
                    meta: {
                        title: '信任中心',
                        showMenu: false,//是否显示
                    }
                }
            ]
        },
        {
            path: '/mb',
            name: 'mb',
            component: () => import('../pages/mb'),
            meta: {
                title: '跳过登录',
                showMenu: false,//是否显示
            }
        },
        {
            path: '/adminorder',
            name: 'adminorder',
            redirect: { name: 'adminorderlists' },
            component: frame,
            meta: {
                title: '订单管理',
                showMenu: true,//是否显示
                icon: "el-icon-monitor",
                userType: 3//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'lists',
                    name: 'adminorderlists',
                    component: () => import('../pages/admin/order'),
                    meta: {
                        title: '订单列表',
                        showMenu: false,//是否显示
                    }
                }
            ]
        },
        {
            path: '/ssldl',
            name: 'ssldl',
            redirect: { name: 'ssldllist' },
            component: frame,
            meta: {
                title: 'SSL代理商',
                showMenu: true,//是否显示
                icon: "el-icon-monitor",
                userType: 3//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'list',
                    name: 'ssldllist',
                    component: () => import('../pages/ssl/list'),
                    meta: {
                        title: 'SSL代理商',
                        showMenu: false,//是否显示
                    }
                }
            ]
        },
        {
            path: '/adminsrc',
            name: 'adminsrc',
            redirect: { name: 'adminsrclist' },
            component: frame,
            meta: {
                title: 'SRC管理',
                showMenu: true,//是否显示
                icon: "el-icon-monitor",
                userType: 3//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'srclist',
                    name: 'adminsrclist',
                    component: () => import('../pages/admin/srclists'),
                    meta: {
                        title: 'SRC管理',
                        showMenu: true,//是否显示
                    }
                }
            ]
        },
        {
            path: '/customer',
            name: 'customer',
            redirect: { name: 'online' },
            component: frame,
            meta: {
                title: '客情管理',
                showMenu: true,//是否显示
                icon: "el-icon-monitor",
                userType: 3//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'online',
                    name: 'online',
                    component: () => import('../pages/admin/customer'),
                    meta: {
                        title: '线上转化',
                        showMenu: true,//是否显示
                    }
                },
                {
                    path: 'artificial',
                    name: 'artificial',
                    component: () => import('../pages/admin/artificial'),
                    meta: {
                        title: '人工录入',
                        showMenu: true,//是否显示
                    }
                },
                {
                    path: 'https',
                    name: 'https',
                    component: () => import('../pages/admin/https'),
                    meta: {
                        title: 'https情报',
                        showMenu: true,//是否显示
                    }
                },
                {
                    path: 'code_signing',
                    name: 'code_signing',
                    component: () => import('../pages/admin/code_signing'),
                    meta: {
                        title: '代码签名',
                        showMenu: true,//是否显示
                    }
                }
            ]
        },
        {
            path: '/article',
            name: 'article',
            redirect: { name: 'articleList' },
            component: frame,
            meta: {
                title: '帮助中心',
                showMenu: true,//是否显示
                icon: "el-icon-tickets",
                userType: 3//1、白帽，2、公司（那种类型下的用户才显示导航）
            },
            children: [
                {
                    path: 'list',
                    name: 'articleList',
                    component: () => import('../pages/admin/srcList'),
                    meta: {
                        title: '帮助列表',
                        showMenu: false,//是否显示
                    }
                },
                {
                    path: 'Operation',
                    name: 'articleOperation',
                    component: () => import('../pages/admin/addSrc'),
                    meta: {
                        title: '发布文章',
                        showMenu: false,//是否显示
                    }
                }
            ]
        }
    ]
})
/**
 * 判断SRC品牌设置的主页标识、企业简称、英文名是否填写
 * 如果没有填写，SRC其他栏目无法进入
 */
function srcBeforeEnter(next) {
    http.etcompanyinfo()
        .then(res => {
            if (!res.Usercompanyimg || !res.Userproducename || !res.Userenglishname) {
                // Message.error('请先完善初始化信息');
                next({ 'name': 'brand' })
            } else if (res.Usercompanyimg && res.Userproducename && res.Userenglishname && res.Userflag == 0) {//判断审核是否通过
                Message.error('你的资料正在审核，请耐心等候！');
                next({ 'name': 'brand' })
            } else if (res.Usercompanyimg && res.Userproducename && res.Userenglishname && res.Userflag == 2) {//判断审核是否通过
                Message.error('抱歉，您的设置已被驳回，请您仔细核对信息，修改后重新提交，谢谢！');
                next({ 'name': 'brand' })
            } else {
                next()
            }
        })
}
router.beforeEach((to, from, next) => {
    let authinf = localStorage.getItem('authinf') ? JSON.parse(localStorage.getItem('authinf')) : '';
    if (!authinf) {
        if (to.meta.intercept) {
            Message.error('请先进行实名认证!');
            next({ 'name': 'authmode' })
        } else {
            next()
        }
    } else if (authinf.examineflag !== 1) {
        if (to.meta.intercept) {
            Message.error('请先进行实名认证!');
            next({ 'name': 'authentication' })
        } else {
            next()
        }
    } else {
        next()
    }
});
// 获取白帽认证信息
function whinfogetauth(next) {
    let authinf = localStorage.getItem('authinf');
    // let authinf='{"keyid":"76cb7dd1be5d1ad31789319ce52e6c08","userkeyid":"eba4bc6cbdb4579faa575f4a7e6da1c6","auth_type":1,"realname":"周浩然","cardnum":"5138***********01X","examineflag":0,"examinetime":1666076182,"examineremark":"审核通过"}';
    // let authinf='';
    // console.log(authinf)
    if (authinf) {
        authinf = JSON.parse(authinf);
        switch (authinf.examineflag) {
            case 0:
                next({ name: 'face' });
                break;
            case 1:
                next();
                break;
            default:
                next({ name: 'applyauth' });
                break;
        }
    } else {
        next({ name: 'applyauth' });
    }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js